import { Component } from "react";
import LoadingSpinner from "@app/shared/LoadingSpinner";
import { ProjectionProviderHistory, ProjectionProviderHistoryEntry } from "../results/projection-provider/projectionProviderHistory";
import ProjectionProviderHistoryEntryDisplay from "./ProjectionProviderHistoryEntryDisplay";
import ProjectionProviderService from "./projectionProviderService";
import { QESAlert } from "@app/shared/qes-standards/Alert";
import { Timeline } from "@app/shared/timeline/Timeline";

interface ProjectionProviderHistoryProps {
  projectionProviderProjectId: number;
  projectionProviderSettingsId: number;
}

interface ProjectionProviderHistoryState {
  history: ProjectionProviderHistory;
  loading: boolean;
}

export default class ProjectionProviderHistoryDisplay extends Component<ProjectionProviderHistoryProps, ProjectionProviderHistoryState> {
  private readonly projectionProviderService = new ProjectionProviderService();

  constructor(props: ProjectionProviderHistoryProps) {
    super(props);

    this.state = {
      history: null,
      loading: true
    }
  }

  public async componentDidMount() {
    await this.projectionProviderService.getProjectionProviderHistory(this.props.projectionProviderProjectId, this.props.projectionProviderSettingsId)
      .then((history) => {
        this.setState({
          history: history,
          loading: false
        });
      })
      .catch(() => {
        this.setState({
          history: null,
          loading: false
        });
      });
  }

  public render() {

    return (
      <>
        {this.state.loading ? <LoadingSpinner /> : <>
          {!this.state.history ? <QESAlert type="danger" persist={true}>Unable to load history for this provider.</QESAlert> : <Timeline>
            {this.state.history.projectionProviderHistoryEntries.map((entry: ProjectionProviderHistoryEntry) => {
              return <ProjectionProviderHistoryEntryDisplay historyEntry={entry} key={entry.historyEntryTime.valueOf()} />;
            })}
          </Timeline>}
        </>}
      </>
    );
  }
}
